import React from "react";
import { formatCharge } from "../utils/formatCharge";
import "../../../../../css/Finance/Charges/ChargesItemRow.css";

const getModifierText = (modifier) => {
  const amount = formatCharge(modifier.amount, "GBP", "+");
  return `(${amount} ${modifier.label.toLowerCase()})`;
};

const ChargesItemRow = ({ item, onEdit, onDelete }) => {
  return (
    <div className="charges-item-row">
      <div className="charges-item-left">
        <div className="charges-item-name">{item.name}</div>

        {!!item.description && (
          <div className="charges-item-description">{item.description}</div>
        )}

        {!!item.modifiers?.length && (
          <div className="charges-item-modifiers">
            {item.modifiers.map((modifier) => (
              <div key={modifier.id} className="charges-item-modifier">
                {getModifierText(modifier)}
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="charges-item-right">
        <div className="charges-item-amount">
          {formatCharge(item.amount, item.currency, item.amountPrefix)}
        </div>

        <div className="charges-item-actions">
          <button type="button" className="charges-item-btn" onClick={onEdit}>
            Edit
          </button>
          <button
            type="button"
            className="charges-item-btn danger"
            onClick={onDelete}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChargesItemRow;
